import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DataService } from './core/services/data.service';
import { HeaderComponent } from './core/components/header/header.component';
import { ArticlesComponent } from './pages/articles/articles.component';
import { MaterialModule } from './modules/material-module';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { LoginModule } from './modules/login/login.module';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { GuidesComponent } from './pages/guides/guides.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    ArticlesComponent,
    LoginPageComponent,
    GuidesComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    HttpClientModule,
    MaterialModule,
    AngularEditorModule,
    LoginModule
  ],
  providers: [DataService],
  bootstrap: [AppComponent]
})
export class AppModule { }
